/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CreateGoal.css";
import { simpleFetch } from "../../restWrapper";
import errorMsg from "../../assets/json/errMsg.json";
import { renderErrorMsg } from "../../assets/component/renderErrorMsg.js";
import PropTypes from "prop-types";
import {
  HEADER_LIMIT,
  MAIN_DOMAIN,
  DEFAULT_LANGUAGE_ARRAY,
  PLATFORM,
} from "../../config";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ReactPlayer from "react-player";
import { checkS3URL } from "../../assets/validators/common.js";
import { getProjectThumbStyle, formatCurrencyAmount, formatDateYMD, getProjectPaymentMethods } from "../../assets/helper.js";
import {
  getProjectDescription,
  toDescriptionContainer,
  descriptionCodeFrom,
  descriptionCodeFields,
  serializeDescriptionCodes,
} from "../../assets/projectContentHelper.js";

import { EditorState, convertToRaw } from "draft-js";
import { QRCodeCanvas } from "qrcode.react";
import { validProjrctInfo } from "../../assets/validators/project.js";
import TextBox from "./TextBox";
import DescriptionCopyMenu from "./DescriptionCopyMenu";
import CustomStatusDropdown from "./CustomStatusDropdown";
import ProjectBulkImport from "../ProjectBulkImport/ProjectBulkImport";
import ExportMenu from "../AccountOverview/ExportMenu";
import MediaGalleryModal from "../AccountOverview/MediaGalleryModal";

class CreateGoal extends Component {
  constructor(props) {
    super(props);

    if (
      this.props.location.state === null ||
      this.props.location.state === undefined
    ) {
      this.props.history.push("/OrgLogin");
    }

    // Copy — pushing onto the shared config export would leak "default"
    // into every other consumer (e.g. ProjectTable's language list)
    let lngArr = [...DEFAULT_LANGUAGE_ARRAY];
    lngArr.push("default");
    this.state = {
      mission: {
        headerBackgroundPicture: [],
        targetAmount: 0,
        donation: PLATFORM === "plug" ? false : true,
        description: EditorState.createEmpty(),
        title: "",
        projectReturnUrl: "",
        status: "open",
        quickReceipt: null,
        hiddenPaymentMethods: [],
      },
      lngArr: lngArr,
      minimumTa: 1,
      loading: false,
      buttonClick: false,
      mode: "manual",
      showImagePicker: false,
    };
    //  this.focus = () => this.refs.editor.focus();
    //    this.onChange = (editorState) => this.setState({editorState});
    this.handleisMultiLanguage = this.handleisMultiLanguage.bind(this);
    this.onBackBtn = this.onBackBtn.bind(this);
    this.handleTitle = this.handleTitle.bind(this);
    this.handleUrl = this.handleUrl.bind(this);
    this.handleDescription = this.handleDescription.bind(this);
    this.handleTABool = this.handleTABool.bind(this);
    this.handleProjectStatus = this.handleProjectStatus.bind(this);
    this.handleType = this.handleType.bind(this);
    this.setProjectData = this.setProjectData.bind(this);
    this.handleTargetAmount = this.handleTargetAmount.bind(this);
    this.onSubmitBtn = this.onSubmitBtn.bind(this);
    this.handleQuickReceipt = this.handleQuickReceipt.bind(this);
    this.handleFeeCoverageModeChange = this.handleFeeCoverageModeChange.bind(this);
    this.handleTogglePaymentMethod = this.handleTogglePaymentMethod.bind(this);
  }

  componentDidMount() {
    try {
      if (!this.props.location.state.isCreatingProject) {
        let m = this.props.location.state.mission;
        if (m.description) {
          m.description = getProjectDescription(
            this.props.language,
            m.description,
            this.state.lngArr,
            "object",
            false
          );
          try {
            if (typeof m.description.isMultiLanguage === "boolean") {
              this.setState({
                isMultiLanguage: m.description.isMultiLanguage,
              });
            }
          } catch (e) {
            this.setState({
              isMultiLanguage: false,
            });
          }
        }

        if (!m.description && m.id) {
          // The project list no longer carries descriptions (CP-229), so a
          // mission navigated here from the table arrives without one. Fetch
          // the full project; render is safe meanwhile (a missing description
          // becomes an empty editor, and Done blocks on !m.description).
          simpleFetch("/projects/" + m.id, "GET")
            .then((res) => {
              if (!res || res.status !== 200 || !res.body || !res.body.description) {
                return;
              }
              // If the user already started typing, don't clobber their text.
              if (this.state.mission.description) return;
              const mission = this.state.mission;
              mission.description = getProjectDescription(
                this.props.language,
                res.body.description,
                this.state.lngArr,
                "object",
                false
              );
              let isMultiLanguage = false;
              try {
                if (typeof mission.description.isMultiLanguage === "boolean") {
                  isMultiLanguage = mission.description.isMultiLanguage;
                }
              } catch (e) {
                isMultiLanguage = false;
              }
              this.setState({ mission, isMultiLanguage });
            })
            .catch(() => {});
        }

        if (m.donation !== true && m.donation !== false) {
          m.donation = PLATFORM === "plug" ? false : true;
        }

        if (m.quickReceipt !== true && m.quickReceipt !== false)
          m.quickReceipt = true;

        // Convert headerBackgroundPicture from string to array if needed
        if (m.headerBackgroundPicture && typeof m.headerBackgroundPicture === 'string') {
          m.headerBackgroundPicture = m.headerBackgroundPicture.split(',');
        }

        this.setState({
          mission: m,
        });
        if (
          this.props.location.state.mission.targetAmount !== null &&
          this.props.location.state.mission.targetAmount > 0.0
        ) {
          this.setState({
            hasTargetAmount: true,
          });
        } else {
          this.setState({
            hasTargetAmount: false,
          });
        }
      }
    } catch (e) {
      this.props.history.push("/OrgLogin");
    }
  }

  onSubmitBtn() {
    // Indicate that the button is clicked
    this.setState({
      buttonClick: true,
    });
    const m = this.state.mission;
    let errMsg = [];
    if (!this.state.hasTargetAmount) {
      m.targetAmount = 0;
      this.setState({
        mission: m,
      });
    } else {
      if (m.targetAmount < this.state.minimumTa) {
        errMsg.targetAmount =
          errorMsg[this.props.language].projectsErr.targetAmount;
      }
    }
    let bool = true;
    const hasMultiLangTitle =
      this.state.isMultiLanguage &&
      m.titleI18n &&
      Object.values(m.titleI18n).some(
        (v) => typeof v === "string" && v.trim().length > 0
      );
    if (!m.title && !hasMultiLangTitle) {
      bool = false;
      errMsg.title = errorMsg[this.props.language].projectsErr.titleErr;
    }

    if (!validProjrctInfo.validUrl(m.projectReturnUrl)) {
      bool = false;
      errMsg.urlErr = errorMsg[this.props.language].projectsErr.urlErr;
    }

    if (!m.description) {
      bool = false;
      errMsg.description =
        errorMsg[this.props.language].projectsErr.descriptionErr;
    }

    this.setState({
      errMsg: errMsg,
    });
    if (!bool) {
      this.setState({
        buttonClick: false,
      });
      return false;
    }

    let descriptionObj = null;
    if (typeof m.description === "object") {
      const lngArr = this.state.lngArr;

      const codes = {};
      for (var i = 0; i < lngArr.length; i++) {
        const content = getProjectDescription(
          lngArr[i],
          m.description,
          null,
          "string",
          true
        );
        codes[lngArr[i]] = JSON.stringify(
          convertToRaw(content.getCurrentContent())
        );
      }
      // Languages identical to default are dropped from storage (CP-234).
      descriptionObj = serializeDescriptionCodes(
        codes,
        typeof this.state.isMultiLanguage === "boolean"
          ? this.state.isMultiLanguage
          : false
      );
    } else {
      descriptionObj = JSON.stringify(
        convertToRaw(m.description.getCurrentContent())
      );
    }

    let titleForSubmit = m.title;
    if (this.state.isMultiLanguage && m.titleI18n) {
      const lngArr = this.state.lngArr;
      for (let i = 0; i < lngArr.length; i++) {
        const v = m.titleI18n[lngArr[i]];
        if (typeof v === "string" && v.trim().length > 0) {
          titleForSubmit = v;
          break;
        }
      }
    }

    let submitObj = {
      title: titleForSubmit,
      titleI18n: this.state.isMultiLanguage && m.titleI18n ? m.titleI18n : {},
      description: descriptionObj,
      targetAmount: m.targetAmount,
      donation: m.donation,
      quickReceipt: m.quickReceipt,
      feeCoverageMode: m.feeCoverageMode || 'default',
      // Always sent, so clearing every toggle clears the stored list (CP-280).
      hiddenPaymentMethods: Array.isArray(m.hiddenPaymentMethods)
        ? m.hiddenPaymentMethods
        : [],
    };
    // Only include headerBackgroundPicture if it exists and has at least one item
    if (m.headerBackgroundPicture && m.headerBackgroundPicture.length > 0) {
      submitObj.headerBackgroundPicture = m.headerBackgroundPicture;
    }
    if (m.projectReturnUrl || m.projectReturnUrl === "")
      submitObj.projectReturnUrl = m.projectReturnUrl;

    if (this.props.location.state.isCreatingProject) {
      simpleFetch("/projects", "POST", submitObj).then((res) => {
        this.setState({
          buttonClick: false,
        });
        switch (res.status) {
          case 200:
            this.props.history.push({
              pathname: "/AccountOverview",
              state: {
                username: this.props.location.state.username,
              },
            });

            break;
          default:
            break;
        }
      });
    } else {
      submitObj.status = m.status;
      simpleFetch("/projects/" + this.state.mission.id, "PUT", submitObj).then(
        (res) => {
          this.setState({
            buttonClick: false,
          });
          switch (res.status) {
            case 200:
              this.props.history.push({
                pathname: "/AccountOverview",
                state: {
                  username: this.props.location.state.username,
                },
              });
              break;
            default:
              break;
          }
        }
      );
    }
  }

  onBackBtn() {
    this.props.history.push({
      pathname: "/AccountOverview",
      state: {
        username: this.props.location.state.username,
      },
    });
  }

  handleTargetAmount(e) {
    let n = e.target.value;
    this.setProjectData(n, "targetAmount");
  }

  // Append one image URL to this project's header images and persist it.
  // Shared by the file upload below and the media-gallery picker, so both
  // paths behave identically.
  attachHeaderImage(url) {
    let data = this.state.mission;
    if (data["headerBackgroundPicture"]) {
      data["headerBackgroundPicture"] =
        data["headerBackgroundPicture"].concat(url);
    } else {
      data["headerBackgroundPicture"] = [url];
    }

    if (this.props.location.state.isCreatingProject) {
      this.setState({
        loading: false,
        mission: data,
      });
      return;
    }
    simpleFetch("/projects/" + this.state.mission.id, "PUT", {
      headerBackgroundPicture: data["headerBackgroundPicture"],
    }).then((res) => {
      // The image stays in the media gallery either way — it's a reusable
      // library entry now, not a per-project upload to clean up on failure.
      this.setState({
        loading: false,
        mission: res.status === 200 ? data : this.state.mission,
      });
    });
  }

  handleTABool(e) {
    if (e.target.value) {
      this.setState({
        hasTargetAmount: !this.state.hasTargetAmount,
      });
    }
  }

  handleisMultiLanguage(e) {
    const bool = !this.state.isMultiLanguage;
    if (e.target.value) {
      this.setState({
        isMultiLanguage: bool,
      });
    }
    const mission = this.state.mission;
    if (bool) {
      const existing = mission.titleI18n || {};
      const seeded = { ...existing };
      DEFAULT_LANGUAGE_ARRAY.forEach((lng) => {
        if (typeof seeded[lng] !== "string") {
          seeded[lng] = mission.title || "";
        }
      });
      mission.titleI18n = seeded;
    } else {
      mission.titleI18n = {};
    }
    this.setState({ mission });
    let newContent = null;
    const description = this.state.mission.description;
    const lngArr = this.state.lngArr;
    if (bool) {
      newContent = {};
      newContent["isMultiLanguage"] = bool;
      try {
        if (
          typeof description !== "object" ||
          typeof description.default === "undefined"
        ) {
          for (let i = 0; i < lngArr.length; i++) {
            newContent[lngArr[i]] = description;
          }
          //    newContent = getProjectDescription()
        } else {
          newContent = description;
          newContent.isMultiLanguage = bool;
        }
      } catch (e) {
        for (let i = 0; i < lngArr.length; i++) {
          if (lngArr[i] === "default") newContent[lngArr[i]] = description;
          else {
            newContent[lngArr[i]] = EditorState.createEmpty();
          }
        }
      }
    } else {
      try {
        if (typeof description === "object") {
          newContent = description;
          if (typeof description["isMultiLanguage"] === "boolean") {
            newContent["isMultiLanguage"] = false;
          }
        }
      } catch (e) {
        return null;
      }
    }
    if (newContent) {
      const mission = this.state.mission;
      mission.description = newContent;
      this.setState({
        mission: mission,
      });
    }
  }

  handleProjectStatus(e) {
    // Directly set the status based on the dropdown selection
    this.setProjectData(e.target.value, "status");
  }
  handleType(e) {
    // Prevent transaction type changes on Plug platform
    if (PLATFORM === "plug") {
      return;
    }
    this.setProjectData(!this.state.mission.donation, "donation");
  }

  handleQuickReceipt(e) {
    this.setProjectData(!this.state.mission.quickReceipt, "quickReceipt");
  }

  handleFeeCoverageModeChange(e) {
    this.setProjectData(e.target.value, "feeCoverageMode");
  }

  // Project-level show/hide for a payment method (CP-280). The stored list is
  // the hidden ones, so "shown" is simply absence - a project the org has
  // never edited keeps following the organisation's settings.
  handleTogglePaymentMethod(key) {
    const hidden = Array.isArray(this.state.mission.hiddenPaymentMethods)
      ? this.state.mission.hiddenPaymentMethods
      : [];
    const next = hidden.indexOf(key) === -1
      ? hidden.concat([key])
      : hidden.filter((k) => k !== key);
    this.setProjectData(next, "hiddenPaymentMethods");
  }

  // Per-project payment method visibility (CP-280). Lists only what the
  // organisation already offers - this narrows a project, it never enables a
  // method the org has not configured, so credentials stay an org concern.
  renderPaymentMethodOverrides(languageObj, currentPlan) {
    // Built from the organisation, not from paymentMethodCode alone: card,
    // express and Link are gated elsewhere in the donor flow and would
    // otherwise never appear for the org admin to control.
    const routerState = this.props.location.state || {};
    const entries = getProjectPaymentMethods(routerState.organizationObj || null, {
      chargesEnabled: routerState.charges_enabled,
    });
    if (entries.length === 0) return null;

    const canOverride = currentPlan === "premium";
    const upgradeHint =
      languageObj.paymentMethodUpgradeHint ||
      "Upgrade to Premium to set payment methods per project";
    const hidden = Array.isArray(this.state.mission.hiddenPaymentMethods)
      ? this.state.mission.hiddenPaymentMethods
      : [];
    // A project that hides everything accepts nothing, which a donor meets as
    // a dead page. Keep the last visible method locked on.
    const visibleCount = entries.filter(
      (entry) => hidden.indexOf(entry.key) === -1
    ).length;
    const lastOneHint =
      languageObj.paymentMethodLastHint ||
      "A project needs at least one payment method";

    return (
      <div className="CreateGoal-paymentMethodsContainer">
        <div className="CreateGoal-paymentMethodsLabel">
          {languageObj.paymentMethodTitle || "Payment Methods"}
        </div>
        <div className="CreateGoal-paymentMethodsDescription">
          {languageObj.paymentMethodDesc ||
            "Follows your organisation settings. Uncheck a method to hide it on this project only."}
        </div>
        <div
          className={`CreateGoal-paymentMethodsList${
            canOverride ? "" : " CreateGoal-paymentMethodsList--disabled"
          }`}
        >
          {entries.map((entry) => {
            const isVisible = hidden.indexOf(entry.key) === -1;
            const isLastVisible = isVisible && visibleCount <= 1;
            const locked = !canOverride || isLastVisible;
            // Why this row cannot be changed. On a free plan that is the
            // upgrade prompt; on premium it only happens to the last visible
            // method. Carried on the row rather than the list so the tooltip
            // appears next to the option the pointer is actually over.
            const lockedHint = !canOverride
              ? upgradeHint
              : isLastVisible
                ? lastOneHint
                : undefined;
            return (
              <label
                className={`CreateGoal-paymentMethodItem${
                  lockedHint ? " CreateGoal-paymentMethodItem--locked" : ""
                }`}
                key={entry.key}
                title={lockedHint}
                data-tooltip={lockedHint}
                tabIndex={lockedHint ? 0 : undefined}
              >
                <input
                  type="checkbox"
                  className="CreateGoal-paymentMethodCheck"
                  checked={isVisible}
                  disabled={locked}
                  aria-disabled={locked}
                  onChange={
                    locked ? undefined : () => this.handleTogglePaymentMethod(entry.key)
                  }
                />
                <span className="CreateGoal-paymentMethodName">{entry.label}</span>
              </label>
            );
          })}
        </div>
      </div>
    );
  }

  handleTitle(e) {
    const value = e.target.value;
    let err = this.state.errMsg;
    if (err && err.title) err.title = "";
    const mission = this.state.mission;
    if (this.state.isMultiLanguage) {
      const existing = mission.titleI18n || {};
      mission.titleI18n = { ...existing, [this.props.language]: value };
    } else {
      mission.title = value;
    }
    this.setState({
      mission,
      errMsg: err,
    });
  }

  handleUrl(e) {
    this.setProjectData(e.target.value, "projectReturnUrl");
  }

  // mission.description is either a {isMultiLanguage, zh, en, cn, default}
  // container of EditorStates or — for legacy single-language content and new
  // projects — a bare EditorState (see componentDidMount's
  // getProjectDescription(..., "object", false) call).
  descriptionContainer() {
    const { mission, lngArr } = this.state;
    return toDescriptionContainer(mission && mission.description, lngArr);
  }



  handleDescription(e) {
    //    this.setProjectData(e,'description');
    let err = this.state.errMsg;
    if (err) {
      if (err["description"]) err["description"] = "";
    }
    let mission = this.state.mission;
    const description = mission["description"];
    let content = null;
    try {
      if (
        typeof description !== "object" ||
        typeof description["default"] !== "object"
      ) {
        content = e;
      } else {
        content = description;
        if (this.state.isMultiLanguage) {
          content[this.props.language] = e;
        } else {
          content["default"] = e;
        }
      }
    } catch (err) {
      content = e;
    }
    mission["description"] = content;
    this.setState({
      mission: mission,
      errMsg: err,
      // Editing invalidates whatever was last copied.
    });
  }

  setProjectData(s, name) {
    let err = this.state.errMsg;
    if (err) {
      if (err[name]) err[name] = "";
    }
    let data = this.state.mission;
    data[name] = s;
    this.setState({
      mission: data,
      errMsg: err,
    });
  }

  renderModeTabs(languageObj, currentPlan) {
    if (!this.props.location.state.isCreatingProject) return null;
    const bulkEnabled = currentPlan === "premium";
    const bulkActive = this.state.mode === "bulk" && bulkEnabled;
    return (
      <div className="CreateGoal-modeTabs">
        <button
          type="button"
          className={
            "CreateGoal-modeTab " +
            (this.state.mode === "manual" ? "is-active" : "")
          }
          onClick={() => this.setState({ mode: "manual" })}
        >
          {languageObj.modeManual || "Create manually"}
        </button>
        <button
          type="button"
          className={
            "CreateGoal-modeTab " +
            (bulkActive ? "is-active " : "") +
            (bulkEnabled ? "" : "is-locked")
          }
          onClick={() => bulkEnabled && this.setState({ mode: "bulk" })}
          disabled={!bulkEnabled}
          title={
            bulkEnabled
              ? ""
              : languageObj.bulkLockTooltip ||
                "Upgrade to Premium to unlock bulk import"
          }
        >
          {languageObj.modeBulk || "Bulk import"}
          <span className="CreateGoal-betaBadge">
            {languageObj.betaBadge || "Beta"}
          </span>
          {!bulkEnabled && (
            <span className="CreateGoal-premiumBadge">
              {languageObj.premiumBadge || "Premium"}
            </span>
          )}
        </button>
      </div>
    );
  }

  renderStatusBtn(languageObj) {
    if (this.props.location.state.isCreatingProject) {
      return null;
    }

    return (
      <div>
        <div className="CreateGoal-subheading">{languageObj.statusText}</div>




        {/* Custom dropdown component (right side) */}
        <CustomStatusDropdown 
          value={this.state.mission.status}
          onChange={this.handleProjectStatus}
        />

        
        {this.state.mission.status === "unlisted" && (

          <div
            className="CreateGoal-unlistedText"
            style={{
              marginTop: "8px",
              fontSize: "12px",
              color: "#666",
              fontStyle: "italic",
            }}
          >
            Project will be accessible via direct link but hidden from homepage
          </div>
        )}
      </div>
    );
  }


  renderTypeBtn(languageObj) {
    // Hide transaction type selector for Plug platform
    if (PLATFORM === "plug") {
      return null;
    }

    // Pill-style segmented control, matching AccountOverview's Overview/List
    // toggle. handleType flips the flag, so the already-selected segment gets
    // no handler -- clicking it must not toggle away from itself.
    const isDonation = this.state.mission.donation;
    return (
      <div
        className="CreateGoal-typeTabs"
        role="tablist"
        aria-label={languageObj.transactionType || "Transaction type"}
      >
        <button
          type="button"
          role="tab"
          aria-selected={isDonation}
          className={
            "CreateGoal-typeTab" +
            (isDonation ? " CreateGoal-typeTab--active" : "")
          }
          onClick={isDonation ? undefined : this.handleType}
        >
          {languageObj.type[0]}
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={!isDonation}
          className={
            "CreateGoal-typeTab" +
            (!isDonation ? " CreateGoal-typeTab--active" : "")
          }
          onClick={isDonation ? this.handleType : undefined}
        >
          {languageObj.type[1]}
        </button>
      </div>
    );
  }

  renderErrMsg() {
    if (!this.state.errMsg) return;
    var acObject = [];
    let items = this.state.errMsg;

    Object.keys(items).forEach(function (i) {
      acObject.push(
        <div key={"key" + i + items["id"]}>{renderErrorMsg(items[i])}</div>
      );
    });

    return <div>{acObject}</div>;
  }

  render() {
    if (
      this.state.loading ||
      this.props.location.state === null ||
      this.props.location.state === undefined
    ) {
      return (
        <div className="CreateGoal-emptyPage">
          <div className="CreateGoal-center">
            <div className="CreateGoal-btm-load"></div>
          </div>
        </div>
      );
    }

    const description = getProjectDescription(
      this.props.language,
      this.state.mission.description,
      this.state.lngArr,
      "string",
      true
    );
    const RenderLanguageSelector = () => {
      const i18n = this.props.i18n;
      const handleChange = (e) => {
        const change = e.target.value;
        i18n.changeLanguage(change);
      };
      return (
        <select onChange={handleChange} value={i18n.language}>
          <option value="zh">繁體中文</option>
          <option value="cn">简体中文</option>
          <option value="en">English</option>
        </select>
      );
    };

    const languageObj = this.props.languageObj;
    const currentPlan = ((this.props.location.state && this.props.location.state.currentPlan) || "").toLowerCase();
    const canUseMultiLanguage = currentPlan === "premium";
    const upgradeHint = "Upgrade to Premium to enable multiple languages";

    if (
      this.props.location.state.isCreatingProject &&
      this.state.mode === "bulk"
    ) {
      return (
        <div className="CreateGoal-view">
          <div className="CreateGoal-prompt">
            <div className="CreateGoal-navigation">
              <div
                className="CreateGoal-backContainer"
                onClick={this.onBackBtn}
              >
                <div className="CreateGoal-back">
                  <div className="CreateGoal-backBtn"></div>
                  <div className="CreateGoal-backText">
                    {languageObj.backText}
                  </div>
                </div>
              </div>
            </div>

            {this.renderModeTabs(languageObj, currentPlan)}

            <ProjectBulkImport
              embedded
              organizationObj={this.props.organizationObj}
              language={this.props.language}
              languageObj={
                this.props.i18n
                  ? this.props.i18n.t("PROJECTBULKIMPORT", {
                    returnObjects: true,
                  })
                  : null
              }
              history={this.props.history}
            />
          </div>
        </div>
      );
    }

    const _deleteItem = () => {
      const isConfirm = window.confirm("Remove this item?");
      if (!isConfirm) return null;
      simpleFetch("/projects/" + this.state.mission.id, "DELETE").then((res) => {
        if (res.status === 204) {
          this.props.history.push({ pathname: "/AccountOverview" });
        }
      });
    };

    const RenderHeader = () => {
      const imgUrl = this.state.mission.headerBackgroundPicture;
      const RenderAddPhotoBtn = (props) => {
        if (imgUrl && imgUrl.length + 1 >= HEADER_LIMIT) return null;
        return (
          // Opens the media gallery, which handles both picking an existing
          // image and uploading a new one — so this replaces the old direct
          // file-input button rather than sitting alongside it.
          <div
            className="CreateGoal-bubbleBtn-left"
            title={languageObj.chooseFromGallery || "Choose from Manage Images"}
            onClick={() => this.setState({ showImagePicker: true })}
          >
            <div className="CreateGoal-uploadpicBtn" />
          </div>
        );
      };

      const RenderAddArrowBtn = (props) => {
        if (imgUrl && imgUrl.length < 2) return null;

        const url = props.url;

        const arrayMove = (old_index, new_index) => {
          let arr = imgUrl;
          if (new_index >= arr.length) {
            let k = new_index - arr.length + 1;
            while (k--) {
              arr.push(undefined);
            }
          }
          arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
          let data = this.state.mission;
          data["headerBackgroundPicture"] = arr;
          this.setState({
            mission: data,
          });
        };

        const onClickLeft = () => {
          for (var i = 1; i < imgUrl.length; i++) {
            if (imgUrl[i] === url) {
              arrayMove(i, i - 1);
              return null;
            }
          }
        };
        const onClickRight = () => {
          for (var i = 0; i < imgUrl.length - 1; i++) {
            if (imgUrl[i] === url) {
              arrayMove(i, i + 1);
              return null;
            }
          }
        };

        return (
          <div className="CreateGoal-leftRight">
            <div className="CreateGoal-bubbleBtn" onClick={onClickLeft}>
              <div className="CreateGoal-leftBtn" />
            </div>

            <div className="CreateGoal-bubbleBtn" onClick={onClickRight}>
              <div className="CreateGoal-rightBtn" />
            </div>
          </div>
        );
      };

      const RenderAddYoutubeBtn = (props) => {
        if (imgUrl.length + 1 >= HEADER_LIMIT) return null;

        const onClickBtn = () => {
          const enterLink = window.prompt("Please enter a YouTube URL");
          if (!enterLink) return null;

          let data = this.state.mission;
          let pictureArray = [];
          pictureArray = data["headerBackgroundPicture"];
          pictureArray.push(enterLink);
          data["headerBackgroundPicture"] = pictureArray;
          this.setState({
            loading: false,
            mission: data,
          });
        };

        return (
          <div className="CreateGoal-bubbleBtn">
            <div className="CreateGoal-youtubeBtn" onClick={onClickBtn} />
          </div>
        );
      };

      if (!imgUrl || imgUrl.length < 1) {
        const headerPictureStyle = getProjectThumbStyle(imgUrl);
        return (
          <div className="CreateGoal-header" style={headerPictureStyle}>
            <div className="CreateGoal-toolBar">
              <RenderAddPhotoBtn />
            </div>
          </div>
        );
      }
      const RenderRemoveBtn = (props) => {
        const url = props.url;

        const checkUrlArray = (obj) => {
          //the url array must more then one image photo
          if (obj.length < 1) return false;

          for (var i = 0; i < obj.length; i++) {
            if (checkS3URL(obj[i])) return true;
          }
          return false;
        };

        if (checkS3URL(url) && !checkUrlArray(imgUrl)) {
          return null;
        }

        const removeFunc = () => {
          let obj = this.state.mission;
          let imgObj = imgUrl;
          for (var i = 0; i < imgObj.length; i++) {
            if (imgObj[i] === props.url) {
              imgObj.splice(i, 1);
            }
          }
          obj.headerBackgroundPicture = imgObj;
          this.setState({
            mission: obj,
          });
        };

        const onClickRemoveBtn = () => {
          // Photos are shared media-gallery entries now — other projects may
          // reuse the same image, so removing it here only detaches it from
          // this project. Deleting the file itself is done from Manage Images,
          // which refuses while any project still uses it.
          const isConfirm = window.confirm(
            checkS3URL(url)
              ? "Remove this photo from the project? The image stays in Manage Images and can be reused."
              : "Remove this youtube from the project?"
          );
          if (!isConfirm) return false;
          removeFunc();
        };

        return (
          <div className="CreateGoal-bubbleBtn-right">
            <div className="CreateGoal-removeBtn" onClick={onClickRemoveBtn} />
          </div>
        );
      };

      return (
        <Carousel showArrows={true} showThumbs={false} showStatus={false}>
          {imgUrl.map((url) => {
            if (checkS3URL(url)) {
              return (
                // image
                <div key={url}>
                  <img src={url} alt={url} />

                  <div className="CreateGoal-toolBar">
                    <RenderAddPhotoBtn />

                    <RenderAddYoutubeBtn />

                    <RenderAddArrowBtn url={url} />

                    <RenderRemoveBtn url={url} />
                  </div>
                </div>
              );
            }
            return (
              // youtube
              <div key={url} style={{ height: "100%" }}>
                <ReactPlayer width={"100%"} height={"100%"} url={url} />
                <div className="CreateGoal-toolBar">
                  <RenderAddPhotoBtn />

                  <RenderAddYoutubeBtn />

                  <RenderAddArrowBtn url={url} />

                  <RenderRemoveBtn url={url} />
                </div>
              </div>
            );
          })}
        </Carousel>
      );
    };

    const RenderQr = () => {
      const subDomain = this.props.location.state.subDomain;
      // Allow QR code for both open and unlisted projects
      const status = this.state.mission.status === "open" || this.state.mission.status === "unlisted";
      if (
        this.props.location.state.isCreatingProject ||
        !subDomain ||
        !this.state.mission.status ||
        !status
      )
        return null;
      const projectId = this.state.mission.id;
      const qrUrl =
        "https://" +
        subDomain +
        "." +
        MAIN_DOMAIN +
        "/MissionDetails?no=" +
        projectId;
        
      const handleViewPage = () => {
        window.open(qrUrl, '_blank');
      };
      
      return (
        <div className="CreateGoal-linkContainer">
          <div className="CreateGoal-QR-container">
            <div className="CreateGoal-QR">
              <QRCodeCanvas
                style={{
                  height: "100%",
                  width: "100%",
                }}
                value={qrUrl}
              />
            </div>
          </div>
          <div className="CreateGoal-view-page-btn" onClick={handleViewPage}>
            <div className="CreateGoal-view-page-icon" />
            <div className="CreateGoal-view-page-text">View Page</div>
          </div>
        </div>
      );
    };

    // Donor count / transaction count / average donation / first & last
    // donation date — merged onto the mission object in AccountOverview.js
    // (GET /organizations/projectStats), so no fetch needed here.
    const RenderStats = () => {
      if (this.props.location.state.isCreatingProject) return null;
      const m = this.state.mission;
      const rows = [
        [languageObj.statsDonorCount || "Donors", m.donorCount != null ? m.donorCount : "—"],
        [languageObj.statsTransactionCount || "Transactions", m.transactionCount != null ? m.transactionCount : "—"],
        [languageObj.statsAverageDonation || "Avg. Donation", formatCurrencyAmount(m.averageDonation)],
        [languageObj.statsFirstDonation || "First Donation", formatDateYMD(m.firstDonation)],
        [languageObj.statsLastDonation || "Last Donation", formatDateYMD(m.lastDonation)],
      ];
      return (
        <div className="CreateGoal-statsPanel">
          {rows.map(([label, value]) => (
            <div className="CreateGoal-statsRow" key={label}>
              <span className="CreateGoal-statsLabel">{label}</span>
              <span className="CreateGoal-statsValue">{value}</span>
            </div>
          ))}
        </div>
      );
    };

    return (
      <div className="CreateGoal-view" data-testid="creategoal-view">
        {this.state.showImagePicker ? (
          <MediaGalleryModal
            mode="picker"
            title={languageObj.chooseFromGallery || "Choose from Manage Images"}
            languageObj={languageObj}
            // Removing an image here only updates local state until the project
            // is saved, so the server would still see it as in use and refuse
            // the delete. Deleting images lives in the Project Manager's Manage
            // Images, where there's no unsaved project state to disagree with.
            allowDelete={false}
            onClose={() => this.setState({ showImagePicker: false })}
            onSelect={(url) => {
              this.setState({ showImagePicker: false, loading: true });
              this.attachHeaderImage(url);
            }}
          />
        ) : null}

        <div className="CreateGoal-prompt">
          <div className="CreateGoal-navigation">
            <div className="CreateGoal-backContainer" onClick={this.onBackBtn}>
              <div className="CreateGoal-back">
                <div className="CreateGoal-backBtn"></div>
                <div className="CreateGoal-backText">
                  {languageObj.backText}
                </div>
              </div>
            </div>

            <RenderQr />

            {this.state.mission.currentAmount === 0 ? (
              <div onClick={_deleteItem} className="CreateGoal-deleteBtn">
                <div className="CreateGoal-deleteIcn" />
              </div>
            ) : null}

            <div
              className="CreateGoal-btn"
              data-testid="creategoal-submit-btn"
              onClick={this.state.buttonClick ? null : this.onSubmitBtn}
              style={{
                pointerEvents: this.state.buttonClick ? 'none' : 'auto',
                opacity: this.state.buttonClick ? 0.6 : 1,
              }}
            >
              {this.state.buttonClick ? languageObj.LoadBtn : languageObj.btn}
            </div>
          </div>

          {this.renderModeTabs(languageObj, currentPlan)}

          <div className="CreateGoal-contentContainer">
            <div className="CreateGoal-mainLeft">
              <div className="CreateGoal-subheading">{languageObj.title}</div>
              <div className="CreateGoal-inputFieldContainer">
                <input
                  type="text"
                  className="CreateGoal-inputField"
                  data-testid="creategoal-title-input"
                  onChange={this.handleTitle}
                  value={
                    (canUseMultiLanguage && this.state.isMultiLanguage
                      ? (this.state.mission.titleI18n &&
                          this.state.mission.titleI18n[this.props.language])
                      : null) ??
                    this.state.mission.title ??
                    ""
                  }
                  placeholder={languageObj.title}
                />
              </div>

              <RenderHeader />
              <div className="CreateGoal-uploadWarning">
                {languageObj.maxUpload}
              </div>

              <div className="CreateGoal-subheading">
                {languageObj.description}
              </div>

              <TextBox
                descriptionContent={description}
                handleDescription={this.handleDescription}
                placeholder={
                  languageObj.descriptionPlaceholder ||
                  "Write the project description here..."
                }
              />

              <DescriptionCopyMenu
                languageObj={languageObj}
                resetKey={this.props.language}
                getCode={() => {
                  const container = this.descriptionContainer();
                  const shown = container && container[this.props.language];
                  return descriptionCodeFrom(shown || container);
                }}
                getFields={() =>
                  descriptionCodeFields(this.descriptionContainer())
                }
              />
            </div>

            <div className="CreateGoal-mainRight">
              <div className="CreateGoal-subheading">
                {languageObj.renderType}
              </div>
              {this.renderTypeBtn(languageObj)}

              {/*
              <div className="CreateGoal-quickReceiptContainer">
                <input
                  className="CreateGoal-quickReceiptCheck"
                  type="checkbox"
                  checked={this.state.mission.quickReceipt}
                  onClick={this.handleQuickReceipt}
                />
                <div className="CreateGoal-quickReceiptSubheading">
                  {languageObj.quickReceiptTitle}
                </div>
                <div className="CreateGoal-quickReceiptDescription">
                  {languageObj.quickReceiptDescription}
                </div>
              </div>
              */}

              <div className="CreateGoal-feeCoverageContainer">
                <div className="CreateGoal-feeCoverageLabel">
                  {languageObj.feeCoverageModeTitle || "Fee Coverage"}
                </div>
                <div className="CreateGoal-feeCoverageDescription">
                  {languageObj.feeCoverageModeDesc || "Override the org-wide fee coverage setting for this project."}
                </div>
                <select
                  className="CreateGoal-feeCoverageSelect"
                  value={this.state.mission.feeCoverageMode || 'default'}
                  onChange={this.handleFeeCoverageModeChange}
                >
                  <option value="default">{languageObj.feeCoverageModeDefault || "Default — Follow system setting"}</option>
                  <option value="optional">{languageObj.feeCoverageModeOptional || "Optional — donor can opt in"}</option>
                  <option value="required">{languageObj.feeCoverageModeRequired || "Required — always applied"}</option>
                  <option value="disabled">{languageObj.feeCoverageModeDisabled || "Disabled — Never Applied and Hidden"}</option>
                </select>
              </div>

              {this.renderPaymentMethodOverrides(languageObj, currentPlan)}

              <div
                className={`CreateGoal-goalCheckContainer${canUseMultiLanguage ? "" : " CreateGoal-goalCheckContainer--disabled"}`}
                title={canUseMultiLanguage ? undefined : upgradeHint}
                data-tooltip={canUseMultiLanguage ? undefined : upgradeHint}
                tabIndex={canUseMultiLanguage ? undefined : 0}
                role="group"
              >
                <input
                  className="CreateGoal-goalCheck"
                  type="checkbox"
                  defaultChecked={this.state.isMultiLanguage}
                  onClick={canUseMultiLanguage ? this.handleisMultiLanguage : undefined}
                  disabled={!canUseMultiLanguage}
                  aria-disabled={!canUseMultiLanguage}
                />
                <div
                  className="CreateGoal-goalCheckSubheading"
                  style={{ opacity: canUseMultiLanguage && this.state.isMultiLanguage ? "1" : "0.5" }}
                >
                  {languageObj.mlText}
                </div>
              </div>

              {canUseMultiLanguage && this.state.isMultiLanguage ? (
                <div className="CreateGoal-mlContainer">
                  <div className="CreateGoal-mlSelector">
                    <RenderLanguageSelector />
                  </div>
                </div>
              ) : null}



            

              <div className="CreateGoal-goalCheckContainer">
                <input
                  className="CreateGoal-goalCheck"
                  type="checkbox"
                  defaultChecked={this.state.hasTargetAmount}
                  onClick={this.handleTABool}
                />
                <div
                  className="CreateGoal-goalCheckSubheading"
                  style={{ opacity: this.state.hasTargetAmount ? "1" : "0.5" }}
                >
                  {languageObj.goalText}
                </div>
              </div>

              <div
                className="CreateGoal-inputFieldContainer"
                style={{ opacity: this.state.hasTargetAmount ? "1" : "0.5" }}
              >
                <input
                  className="CreateGoal-inputField"
                  type="number"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  style={{
                    color: this.state.hasTargetAmount ? "#000000" : "#afafaf",
                  }}
                  disabled={!this.state.hasTargetAmount}
                  value={this.state.mission.targetAmount}
                  onChange={this.handleTargetAmount}
                />
              </div>
              {this.renderStatusBtn(languageObj)}

              <RenderStats />

              {!this.props.location.state.isCreatingProject ? (
                <div className="CreateGoal-exportRow">
                  <ExportMenu
                    projectIds={[this.state.mission.id]}
                    languageObj={languageObj}
                  />
                </div>
              ) : null}

              <div className="CreateGoal-subheading">
                {languageObj.projectReturnUrl}
              </div>
              <div className="CreateGoal-inputFieldContainer">
                <input
                  type="text"
                  className="CreateGoal-inputField"
                  onChange={this.handleUrl}
                  value={this.state.mission.projectReturnUrl}
                  placeholder={languageObj.projectReturnUrl}
                />
              </div>

              {this.renderErrMsg()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CreateGoal.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
  i18n: PropTypes.object,
  organizationObj: PropTypes.object,
};

export default CreateGoal;
